import styled from 'styled-components';

import { colors, fonts } from 'stylesheets';

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ invoices }) => (invoices ? 'space-between' : 'flex-end')};
`;

export const Content = styled.div`
  max-height: 80vh;
`;

export const SelectStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Label = styled.div`
  font-size: 14px;
  font-family: ${fonts.secondary};
  color: ${colors.greyDark};
`;

export const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${fonts.primary};
  font-size: 20px;
`;

export const Loader = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

export const List = styled.div`
  width: 100%;
  max-height: 50vh;
  overflow: auto;
  padding: 0 1rem;
  margin: 1.5rem auto;
`;

export const Footer = styled.div`

`;
